import { CALL_AUTHORIZATION_MANAGEMENT_API } from '../../middleware/authHeaders'
import { AUTHORIZATION_MANAGEMENT_API_ROOT } from '../../config/api'

// ACTION TYPES
export const AUDIT_HISTORY_SEARCH_REQUEST = 'AUDIT_HISTORY_SEARCH_REQUEST'
export const AUDIT_HISTORY_SEARCH_SUCCESS = 'AUDIT_HISTORY_SEARCH_SUCCESS'
export const AUDIT_HISTORY_SEARCH_FAILURE = 'AUDIT_HISTORY_SEARCH_FAILURE'

// ACTION CREATORS
export const searchAuditHistory =
  (contextId, params = {}) =>
  dispatch => {
    const queryParams = new URLSearchParams({
      contextId,
      page: params.page || 1,
      pageSize: params.pageSize || 20,
      ...params,
    }).toString()

    return dispatch({
      [CALL_AUTHORIZATION_MANAGEMENT_API]: {
        method: 'GET',
        endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/AuditHistory/search?${queryParams}`,
        types: [
          AUDIT_HISTORY_SEARCH_REQUEST,
          AUDIT_HISTORY_SEARCH_SUCCESS,
          AUDIT_HISTORY_SEARCH_FAILURE,
        ],
      },
    })
  }

export const AUDIT_HISTORY_ROLE_SUGGESTIONS_REQUEST = 'AUDIT_HISTORY_ROLE_SUGGESTIONS_REQUEST'
export const AUDIT_HISTORY_ROLE_SUGGESTIONS_SUCCESS = 'AUDIT_HISTORY_ROLE_SUGGESTIONS_SUCCESS'
export const AUDIT_HISTORY_ROLE_SUGGESTIONS_FAILURE = 'AUDIT_HISTORY_ROLE_SUGGESTIONS_FAILURE'

export const getAuditHistoryRoleNameSuggestions = (contextId, searchText) => dispatch => {
  const queryParams = new URLSearchParams({
    searchText,
  }).toString()

  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'GET',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/AuditHistory/contexts/${contextId}/suggestions/roleName?${queryParams}`,
      types: [
        AUDIT_HISTORY_ROLE_SUGGESTIONS_REQUEST,
        AUDIT_HISTORY_ROLE_SUGGESTIONS_SUCCESS,
        AUDIT_HISTORY_ROLE_SUGGESTIONS_FAILURE,
      ],
    },
  })
}

// SELECTORS
const selectAuditHistorySlice = state => state.authorizationManagement?.auditHistory || {}

export const selectAuditHistory = state => selectAuditHistorySlice(state).auditLogs
export const selectAuditHistoryLoading = state => selectAuditHistorySlice(state).isLoading
export const selectAuditHistoryError = state => selectAuditHistorySlice(state).error
export const selectAuditHistoryPagination = state => selectAuditHistorySlice(state).pagination
export const selectAuditHistoryFacets = state => selectAuditHistorySlice(state).facets
export const selectAuditHistorySuggestions = state => selectAuditHistorySlice(state).suggestions

const initialState = {
  auditLogs: [],
  isLoading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalItems: 0,
  },
  facets: {},
  suggestions: {
    roleName: [],
  },
}

// REDUCERS
const auditHistory = (state = initialState, { type, payload } = {}) =>
  ({
    [AUDIT_HISTORY_SEARCH_REQUEST]: currentState => ({
      ...currentState,
      isLoading: true,
      error: null,
    }),
    [AUDIT_HISTORY_SEARCH_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      isLoading: false,
      auditLogs: newPayload?.items || newPayload || [],
      pagination: {
        currentPage: newPayload?.page || 1,
        pageSize: newPayload?.pageSize || 20,
        totalPages: newPayload?.totalPages || 0,
        totalItems: newPayload?.totalItems || newPayload?.items?.length || 0,
      },
      facets: newPayload?.facets || {},
    }),
    [AUDIT_HISTORY_SEARCH_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      isLoading: false,
      error: newPayload?.message || 'Failed to fetch audit history',
    }),
    [AUDIT_HISTORY_ROLE_SUGGESTIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      suggestions: {
        ...currentState.suggestions,
        roleName: newPayload ?? [],
      },
    }),
  }[type]?.(state, payload) || state)

export default auditHistory
